import React from "react";
import { Link } from "react-router-dom";
import expg from "../../../Assets/Images/cards/expg.png";
import './style.css'
import { isValidString } from "../../../helper";
const ExperientialProgramCard = ({ data }) => {

  const RegisterButtons = ({ item }) => {
    if (item?.register_as_individual && item?.register_as_team) {
      return (
        <div className="dropdown experientialcards">
          <button className="btn chmpn-pnk-btn" type="button" id="select-register" data-bs-toggle="dropdown" aria-expanded="false">
            Register now
          </button>
          <ul className="dropdown-menu slct-drop-menu" aria-labelledby="select-register">
            <li>
              <Link className="dropdown-item" to={{ pathname: `/champions/${item.event_code}/register/individual`, state: item }}>
                Register as an individual
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to={{ pathname: `/champions/${item.event_code}/register/team`, state: item }}>
                Register as a team
              </Link>
            </li>
          </ul>
        </div>
      )
    } else if (item?.register_as_individual && item?.is_quiz_only) {
      return (
        <div className="dropdown experientialcards">
          <Link className="btn chmpn-pnk-btn" style={{ padding: "8px 10px" }} to={{ pathname: `/champions/${item?.event_code}`, state: item }}>
            Register now
          </Link>
        </div>
      )
    } else if (item?.register_as_individual) {
      return (
        <div className="dropdown experientialcards">
          <Link className="btn chmpn-pnk-btn" style={{ padding: "8px 10px" }} to={{ pathname: `/champions/${item?.event_code}/register/individual`, state: item }}>
            Register now
          </Link>
        </div>
      )
    }
    return <div className="dropdown experientialcards"></div>;
  }

  return (
    <React.Fragment>
      <div className="competitions-content-slider col-12 experiential-cards-list my-5">
        <div class="competitions-item-outer col-md-4 px-2 mx-auto w-100">
          <div className="competitions-item"><Link><img className="chmpn-slider-img" src={isValidString(data?.image_url) ? data?.image_url : expg} /></Link>
            <div className="card-title">{data?.event_name}</div>
            <div className="card-banner-data">
              <div className="age-bar">{(data?.min_age === data?.max_age) ? data?.min_age : `${data?.min_age}-${data?.max_age}`} years</div>
              <div className="total-activities">{data?.activity_count} {data?.activity_count > 1 ? 'activities' : 'activity'}</div>
            </div>
            <div className="chmpn-slider-content experiential-cards chmpn-register-select-btn ">
              {/* <RegisterButtons item={data} /> */}
              <Link to={data?.is_quiz_only ? "/quiz-program-detail" : `/learning-programs/${data?.event_code}`} state={{ eventCode: data?.event_code }} className="nav-link explore-nav">Explore more</Link>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExperientialProgramCard;
